import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Home, MessageSquare, ArrowLeft } from 'lucide-react'
export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found — Illuminate Faith</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="min-h-screen bg-[var(--bg-base)] flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <p className="text-6xl font-heading font-bold text-[var(--gold)] mb-4">404</p>
          <h1 className="text-2xl font-heading font-bold text-[var(--text-primary)] mb-3">
            Page Not Found
          </h1>
          <p className="text-[var(--text-muted)] mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 px-5 py-3 bg-[var(--gold)] text-[var(--text-on-gold)] font-semibold rounded-xl hover:brightness-110 transition-all w-full sm:w-auto justify-center"
            >
              <Home className="w-4 h-4" aria-hidden="true" />
              Go Home
            </Link>
            <Link
              to="/home"
              className="flex items-center gap-2 px-5 py-3 border border-[var(--glass-border)] text-[var(--text-primary)] font-semibold rounded-xl hover:bg-[var(--bg-surface)] transition-all w-full sm:w-auto justify-center"
            >
              <MessageSquare className="w-4 h-4" aria-hidden="true" />
              Open Dashboard
            </Link>
          </div>
          <button
            onClick={() => window.history.back()}
            className="mt-6 text-sm text-[var(--text-muted)] hover:text-[var(--gold)] transition-colors flex items-center gap-1 mx-auto"
          >
            <ArrowLeft className="w-3.5 h-3.5" aria-hidden="true" />
            Go back
          </button>
        </div>
      </div>
    </>
  )
}
